import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';

const colors = {
  filledPrimary: 'var(--black)',
  error: 'var(--red3)',
  success: 'var(--green5)',
  info: 'var(--white)',
  loading: 'var(--primary3)',
  disabled: 'var(--gray3)',
  blue: 'var(--blue3)',
  yellow2: 'var(--yellow2)',
  active: 'var(--primary2)',
};

type ButtonType = keyof typeof colors;

type FontSizes = 'medium';

// Shared button style used also in mobile Link component
const buttonMobileCss = css<{
  $noBorder?: boolean;
  $fontSize?: FontSizes;
  onClick?: (event?: unknown) => void;
  $isClickable?: boolean;
  $buttonType?: ButtonType;
}>`
  display: inline-block;
  cursor: ${props =>
    props.onClick || props.$isClickable ? 'pointer' : 'initial'};
  color: ${({ $noBorder, $buttonType }) =>
    $noBorder
      ? $buttonType
        ? colors[$buttonType]
        : 'var(--mainLight)'
      : 'var(--white)'};
  font-size: ${props =>
    props.$fontSize
      ? props.$fontSize === 'medium'
        ? 'var(--medium)'
        : 'var(--smaller)'
      : 'var(--smaller)'};
  font-weight: normal;
  background-color: ${({ $buttonType }) =>
    $buttonType === 'filledPrimary' ? 'var(--main)' : 'initial'};
  text-align: center;
  text-decoration: none;
  ${({ $noBorder, $buttonType }) =>
    $noBorder
      ? ''
      : css`
          border: 1px solid ${$buttonType ? colors[$buttonType] : 'var(--main)'};
          border-radius: 4px;
        `}
  padding: 5px 9px;
  margin: 0 5px;
  ${({ onClick }) =>
    onClick &&
    css`
      &:hover {
        filter: brightness(1.2);
      }
    `}
`;

const Button = styled.div<{
  $noBorder?: boolean;
  $fontSize?: FontSizes;
  $buttonType?: ButtonType;
  $noMargin?: boolean;
  onClick?: () => void;
  $background?: boolean;
}>`
  ${buttonMobileCss}
  ${props =>
    props.$noMargin
      ? css`
          margin: 0;
        `
      : ''}
`;

// const LinkStyled = styled(({ to, children, style, className }) => (
//   <Link to={to} style={style} className={className}>
//     {children}
//   </Link>
// ))<{
//   noBorder?: boolean;
//   fontSize?: FontSizes;
// }>`
//   ${buttonMobileCss}
// `;

type IProps = {
  children?: ReactNode;
  onClick?: () => void;
  noBorder?: boolean;
  disabled?: boolean;
  type?: ButtonType;
  fontSize?: FontSizes;
  noMargin?: boolean;
  title?: string;
};

function SimpleRoundedButton({
  onClick,
  noBorder,
  disabled = false,
  type,
  fontSize,
  noMargin,
  title,
  children,
}: IProps) {
  return (
    <Button
      onClick={disabled ? undefined : onClick}
      $noBorder={noBorder}
      $fontSize={fontSize}
      $buttonType={disabled ? 'disabled' : type}
      $noMargin={noMargin}
      title={title}
    >
      {children}
    </Button>
  );
}

// type IPropsLink = Omit<IProps, 'onClick'> & {
//   to: string;
// };
// export function SimpleRoundedButtonLink({
//   to,
//   noBorder,
//   fontSize,
//   children,
// }: IPropsLink) {
//   return (
//     <LinkStyled to={to} noBorder={noBorder} fontSize={fontSize} isClickable>
//       {children}
//     </LinkStyled>
//   );
// }

export default SimpleRoundedButton;
